import moment from 'moment'
export default {
  state: {
    dateEvent: '',
    venueEvent: '',
    hourEvent: '',
    monthEvent: '',
    dayEvent: ''
  },
  getters: {
    getZone (state) {
      return state
    }
  },
  mutations: {
    setZone (state, payload) {
      state.dateEvent = moment(payload.date).format('dddd, DD [de] MMMM YYYY')
      state.venueEvent = payload.venue
      state.hourEvent = payload.hour
      state.monthEvent = moment(payload.date).format('MMMM').slice(0, 3)
      state.dayEvent = moment(payload.date).format('DD')
    }
  },
  actions: {
    setData ({commit}, payload) {
      commit('setZone', payload)
      localStorage.setItem('infoEvent', JSON.stringify(payload))
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/zone-selection.store.js